'use strict';

angular.module('atex.art').factory('ArtDeskEmbed',['$q', '$injector', '$location',
                                  'UIConfigurationService', 'ArtPrintData',
  function($q, $injector, $location,
           UIConfigurationService, ArtPrintData) {
    function ArtDeskEmbed() {}

    var scope;
    var ShapeUtils;
    var ADMUtils;
    var PrintService;

    function encodeEmbedData( dataToEmbed ) {
      var encodedString = new TextEncoder().encode(JSON.stringify(dataToEmbed));

      var binString = "";
      for (var i = 0; i < encodedString.length; i++) {
        binString += String.fromCodePoint(encodedString[i]);
      }

      return encodeURIComponent(btoa(binString));
    }

    var isNew = function () {
      return (/\/new\//).test($location.path());
    };

    var addEmebdedDeskListener = function() {
      if ( !scope.desk.listener ) {
        scope.desk.listener = true;
        document.addEventListener('embed', embedDeskListener );
      }
    };

    var openDeskIFrameUrl = function(url) {
      scope.desk.url = url;
    };

    var closeDeskFrame = function() {
      openDeskIFrameUrl("");
      scope.$apply(function() {
        scope.desk.showing = false;
      });
    };

    var cancel = function() {
      scope.desk.deferred.resolve({ saveAndClose: false });
    };

    var saveAndClose = function(options) {
      scope.desk.deferred.resolve({ saveAndClose: true, options: options});
    };

    var linkToPrint = function( id, publEvent, queue ) {
      var contentOptions = {
        contentId: id,
        layoutOptions: {
          pending: true,
          publEvent: publEvent ? JSON.stringify(publEvent): '',
          queue: queue
        },
        subType: 'linkToPrint'
      };

      if ( !PrintService ) {
        PrintService = $injector.get("PrintService");
      }

      return PrintService.content(contentOptions);
    };

    var embedDeskListener = function( event ) {
      if ( event.detail ) {
        var detail = event.detail;

        if ( !ShapeUtils ) {
          ShapeUtils = $injector.get("ShapeUtils");
        }

        if ( detail.shapesObj && detail.field && detail.publEvent && detail.subject === scope.desk.callerId ) {
          if ( event.detail.message === 'embed:save') {
            if ( detail.shapesObj.shapeMode === ShapeUtils.LINK_TO_PRINT ) {
              var isLinkedContent = ArtPrintData.isArticleLinked(scope.article);
              var newPublEvent = detail.publEvent;

              var updateEvent = scope.desk['link-to-page'];
              var updateQueue = scope.desk['select-queue'] ? !_.isEmpty(newPublEvent.queue) : false;


              var publeventsDO = atex.onecms.DomainObjectUtils.getDomainObjectByPath(scope.topDomainObject, 'aspects/atex.dam.standard.Publevents/data');
              if (publeventsDO) {
                var publevents = publeventsDO.getData();

                if (publevents && publevents.publevents && publevents.publevents.length > 0 && newPublEvent ) {
                  var publEvent = publevents.publevents[0];

                  if (!ADMUtils) {
                    ADMUtils = $injector.get("ADMUtils");
                  }

                  updateQueue = scope.desk['select-queue'] && newPublEvent.queue && newPublEvent.queue !== publEvent.queue;

                  updateEvent = false;

                  if ( scope.desk['link-to-page'] ) {
                    if (detail.selectedShape && detail.selectedShape.shape_id) {
                      if (detail.selectedShape.shape_id.toString() !== publEvent.docId) {
                        updateEvent = true;
                        newPublEvent.docId = detail.selectedShape.shape_id.toString();
                      }
                      if (detail.selectedShape.page !== publEvent.page) {
                        updateEvent = true;
                        newPublEvent.page = detail.selectedShape.page;
                      }
                    }

                    if (!ADMUtils.PublEventUtils.match(newPublEvent, publEvent)) {
                      updateEvent = true;
                    }
                  }
                }
              }

              if (updateEvent || updateQueue) {
                if ( isLinkedContent ) {
                  saveAndClose( {
                      queue: updateQueue ? newPublEvent.queue : '',
                      publEvent: updateEvent ? JSON.stringify(newPublEvent) : ''
                    });
                } else {
                  // Update Print Variant so that it is processed when it is linked to print.
                  var printVariantDO = ArtPrintData.getPrintVariantsDomainObject(scope.topDomainObject);

                  if (printVariantDO) {
                    var publ = printVariantDO.getPublEvent();
                    if (!publ) {
                      if (updateEvent) {
                        publ = newPublEvent;
                      } else {
                        publ = { queue: newPublEvent.queue };
                      }
                    } else {
                      if (updateEvent) {
                        publ = newPublEvent;
                      } else {
                        publ.queue = newPublEvent.queue;
                      }
                    }
                    printVariantDO.setPublEvent(publ);
                    printVariantDO.changed();
                  }

                  if ( isNew() ) {
                    saveAndClose();
                  } else {
                    linkToPrint( scope.desk.contentId, updateEvent ? newPublEvent : '', updateQueue ? newPublEvent.queue : '' ).then(function() {
                      saveAndClose();
                    }).catch(function(error) {
                      console.warn("desk-embed linkToPrint catch error = ", error);
                      saveAndClose();
                    });
                  }
                }
              }
              else {
                cancel();
              }

              closeDeskFrame();
            }
          } else if ( event.detail.message === 'embed:cancel') {
            if ( detail.shapesObj.shapeMode === ShapeUtils.LINK_TO_PRINT ) {
              closeDeskFrame();
              scope.desk.deferred.resolve({ saveAndClose: false, options: {}});
            }
          }
        }
      }
    };

    var getContentObjectType = function() {
      return atex.onecms.ObjectUtils.getByPath(scope.article, 'data/aspects/contentData/data/objectType');
    };

    var isToolbarButtonVisible = function(toolbar) {
      var config = (toolbar ? toolbar.config : undefined) || {};
      var objectTypes = config.objectTypes || ['article', 'image'];
      return objectTypes.includes(getContentObjectType());
    };

    ArtDeskEmbed.initSaveAndSend = function(detailsScope) {
      scope = detailsScope;

      scope.desk.showing = false;

      scope.desk.visibleLinkToPage = false;
      scope.desk.visibleSendToQueue = false;
      scope.desk.url = "";
      scope.desk['link-to-page'] = false;
      scope.desk['select-queue'] = false;
      scope.desk.queueOnly = false;
      scope.desk.callerId = Date.now().toString();
      scope.desk.listening = false;

      UIConfigurationService.toolbar("send-to-queue").then(function (toolbar) {
        scope.desk.visibleSendToQueue = false;
        if (toolbar && toolbar.visible) {
          scope.desk.visibleSendToQueue = isToolbarButtonVisible(toolbar);
          addEmebdedDeskListener();
        }
      });
      UIConfigurationService.toolbar("link-to-page").then(function (toolbar) {
        scope.desk.visibleLinkToPage = false;
        if (toolbar && toolbar.visible) {
          scope.desk.visibleLinkToPage = isToolbarButtonVisible(toolbar);
          addEmebdedDeskListener();
        }
      });
    };

    ArtDeskEmbed.openDeskFrame = function() {
      scope.desk.deferred = $q.defer();

      if (!isNew() && scope.article && scope.article.meta && scope.article.meta.id) {
        scope.desk.article = scope.article;
        scope.desk.template = scope.article.template;
        scope.desk.contentId = scope.article.meta.id;

        var domainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath(scope.topDomainObject, 'aspects/prestige.ContentData/data/queue');
        if(typeof domainObject !== 'undefined') {
          scope.desk.queue = domainObject.getData();
        }

        if (!scope.desk.queue) {
          var printVariantDO = ArtPrintData.getPrintVariantsDomainObject(scope.topDomainObject);

          if (printVariantDO) {
            var publ = printVariantDO.getPublEvent();
            if (publ) {
              scope.desk.queue = publ.queue;
            }
          }
        }

        var deskUrl = '/desk/#/embed/link-to-page/' + scope.desk.contentId +
            '?embedData=' + encodeEmbedData(scope.desk) +
            '&callerId=' + encodeURIComponent(scope.desk.callerId) +
            '&noHeader=true';

        if (!scope.desk.showing || scope.desk.url === deskUrl) {
          openDeskIFrameUrl(deskUrl);
          scope.desk.showing = true;

          return scope.desk.deferred.promise;
        }
      }

      return $q.when();
    };

    ArtDeskEmbed.CreateDeskDetails = function() {
      return {
        showing: false,
        visibleLinkToPage: false,
        visibleSendToQueue: false,
        url: ""
      };
    };

    ArtDeskEmbed.prototype = {
      constructor: ArtDeskEmbed
    };

    return(ArtDeskEmbed);
  }]);
